import QRCodeStyling from "qr-code-styling";
import { useEffect, useRef } from "react";
import { inject, observer } from "mobx-react";
import { Store } from "stores/store";
import { use4K } from "@/lib/utils";

type SelfieProps = {
    store?: Store;
};

const QrCode: React.FC<SelfieProps> = ({ store }) => {
    if (!store) {
        throw Error("Component was not setup correctly");
    }

    const { qrCodeImageUrl } = store;

    const qrCode = useRef<QRCodeStyling | null>(null);
    const containerRef = useRef(null);

    const is4k = use4K();
    const width = is4k ? 260 : 260
    const height = is4k ? 260 : 260
    const margin = is4k ? 8 : 8

    useEffect(() => {
        qrCode.current = new QRCodeStyling({
            width: width,
            height: height,
            margin: margin,
            dotsOptions: {
                color: "#000000",
                type: "rounded",
            },
            backgroundOptions: {
                round: is4k ? 0.3 : 0.3,
            },
            cornersDotOptions: {
                type: is4k ? "extra-rounded" : "extra-rounded",
            },
            cornersSquareOptions: {
                type: is4k ? "extra-rounded" : "extra-rounded",
            },
        });
    }, []);

    useEffect(() => {
        if (containerRef.current && qrCode.current) {
            qrCode.current.append(containerRef.current);
        }
    }, []);

    useEffect(() => {
        console.log("qrCodeImageUrl ", qrCodeImageUrl)
        if (qrCode.current && qrCodeImageUrl) {
            qrCode.current.update({
                data: qrCodeImageUrl,
            });
        }
    }, [qrCodeImageUrl]);

    return (
        <div
            ref={containerRef}
            className="4xl:min-w-[260px] 4xl:max-w-[260px] 4xl:w-[260px] 4xl:h-[260px] 4xl:max-h-[260px] 4xl:min-h-[260px] min-w-[65px] max-w-[65px] w-[65px] h-[65px] max-h-[65px] min-h-[65px] relative"
        />
    );
};

export default inject("store")(observer(QrCode));